var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5C13.6569 14.5 15 13.1569 15 11.5C15 9.84315 13.6569 8.5 12 8.5C10.3431 8.5 9 9.84315 9 11.5C9 13.1569 10.3431 14.5 12 14.5Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5068 16.25C19.7218 17.58 18.8387 17.96 17.1706 17.39C16.0912 17.01 14.8156 17.675 14.6193 18.815C14.3249 20.525 13.5399 21 11.9699 21C10.3999 21 9.61492 20.43 9.32055 18.815C9.1243 17.675 7.84867 17.01 6.76929 17.39C5.10115 17.96 4.21803 17.58 3.43302 16.25C2.64802 15.015 2.9424 13.97 4.21803 12.925C5.10115 12.165 5.00303 10.835 4.1199 10.17C2.84427 8.935 2.74615 8.08 3.53115 6.75C4.31615 5.515 5.29741 5.23 6.86741 5.705C7.94679 6.085 9.1243 5.325 9.32055 4.28C9.71305 2.57 10.3999 2 12.0681 2C13.5399 2 14.3249 2.76 14.6193 4.375C14.8156 5.42 16.0912 6.085 17.1706 5.705C18.8387 5.04 19.7218 5.42 20.5068 6.75C21.2918 8.08 21.1937 8.935 19.82 10.075C18.9368 10.835 18.9368 12.165 19.82 12.925C21.1937 14.065 21.2918 14.92 20.5068 16.25Z",
    stroke: "current",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.1a9c57a01a8cbcc63d9183bf213b758c.svg";
export { ForwardRef as ReactComponent };